export const DEFAULT_MODAL_STATE = {
  isOpen: false,
  context: null
};
